// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"7939a6a5","220":"5d3a4670","228":"41093110","277":"5f6b0989","408":"331cec30","434":"44c469ee","969":"359fed9b"}[chunkId] + ".chunk.js";
};